import PropTypes from 'prop-types';
import React from 'react';
import { useLabels } from 'wsm-common-data';

const CarouselButton = ({ direction, clickEvent, mouseUpEvent, classes }) => {
	const labels = useLabels();
	const marginClass = direction === 'right' ? 'mr-4' : 'ml-4';
	const type =
		direction === 'right'
			? labels.get('NEXT_PHOTO')
			: labels.get('PREVIOUS_PHOTO');

	const arrowKey =
		direction === 'right'
			? labels.get('RIGHT_ARROW')
			: labels.get('LEFT_ARROW');

	let buttonClasses = ['btn-carousel', 'p-0', 'd-block', marginClass, 'btn'];

	if (classes) {
		buttonClasses = [...buttonClasses, ...classes];
	}

	const iconClasses = [
		'ddc-icon',
		'ddc-icon-carousel-arrow',
		`ddc-icon-carousel-arrow-${direction}`,
		'd-block'
	];
	return (
		<button
			className={buttonClasses.join(' ')}
			onClick={clickEvent}
			onMouseUp={mouseUpEvent}
			title={`${type} (${arrowKey})`}
			aria-label={`${type} (${arrowKey})`}
			type="button"
		>
			<i className={iconClasses.join(' ')} />
		</button>
	);
};

CarouselButton.propTypes = {
	direction: PropTypes.string.isRequired,
	clickEvent: PropTypes.func.isRequired,
	mouseUpEvent: PropTypes.func,
	classes: PropTypes.arrayOf(PropTypes.string)
};

CarouselButton.defaultProps = {
	mouseUpEvent: () => null,
	classes: []
};

export default CarouselButton;
